
import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import CloseIcon from '@material-ui/icons/Close';
import Slide from '@material-ui/core/Slide';
import Container from '@material-ui/core/Container';

import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Accordion from '@material-ui/core/Accordion';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { makeStyles } from '@material-ui/core/styles';
import { legalNotice } from './__data';

const useStyles = makeStyles((theme) => ({
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  root: {
    boxShadow: 'none !important'
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular,
    marginTop: '2rem',
  },
}));

const Transition = React.forwardRef(function Transition(props, ref) {
  return (
    <Slide
      direction="up"
      ref={ref}
      {...props}
    />
  )
});

// eslint-disable-next-line react/no-multi-comp
export default function FullScreenDialog() {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Button
        color="secondary"
        onClick={handleClickOpen}
        size="sm"
        style={{textTransform: 'capitalize', color: 'rgb(112, 195, 89)'}}
      >
        Mentions Légales
      </Button>
      <Dialog
        TransitionComponent={Transition}
        fullScreen
        onClose={handleClose}
        open={open}
      >
        <AppBar
          className={classes.appBar}
          color="secondary"
        >
          <Container>
            <Toolbar>
              <IconButton
                aria-label="close"
                color="inherit"
                edge="start"
                onClick={handleClose}
              >
                <CloseIcon />
              </IconButton>
              <Typography
                className={classes.title}
                variant="h6"
              >
              Mentions Légales
              </Typography>
            </Toolbar>
          </Container>
        </AppBar>
        <Container className={classes.root}>

          {legalNotice.map((rule, index) => { return (
            <Accordion
              className={classes.root}
              expanded={expanded === index}
              key={`rule + ${index}`}
              onChange={handleChange(index)}
            >
              <AccordionSummary
                aria-controls="panel1bh-content"
                expandIcon={<ExpandMoreIcon />}
                id="panel1bh-header"
              >
                <Typography
                  className={classes.heading}
                  component="h3"
                  variant="h3"
                >{rule.title}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography >
                  
                  {rule.content}
                </Typography>
              </AccordionDetails>
            </Accordion>
          )})}

        </Container>
      </Dialog>
    </>
  );
}
